/*
 * author: Jimmy
 * createdTime: 2018/01/18
 * */
import React, { PureComponent } from 'react';
import { Layout, Tabs, Icon } from 'antd';
import GlobalHeader from './components/GlobalHeader';
import GlobalSlider, { logOut } from './components/GlobalSlider';
import './style/reset.less';
import { getVariant, hasVariant } from '@Variant';
import { connect } from 'react-redux';
import { history } from '@RouterAdmin';
import { mapDispatchToProps } from '../../redux/map';
import { getData, getSupplierCode, setSupplierCodePiaoSwitch } from '@util';
import _ from 'lodash';
import { API_GET_PIAOHE_GRAY_SWITCH, API_GET_SETTLE_SIGNDATA_ISSIGNSUPPLIER } from '@api';

const TabPane = Tabs.TabPane;
const homePath = '/home/index';
const registeredPath = '/registered';
const supplierRegisteredPath = '/home/profile';
let title;
function getTitleNameFromPathMap(arr, pathname) {
  for (let i = 0; i < arr.length; i++) {
    if (`/${arr[i].path}` === pathname) {
      title = arr[i].name;
      break;
    } else if (Array.isArray(arr[i].children)) {
      getTitleNameFromPathMap(arr[i].children, pathname);
    }
  }
  return title;
}

@connect(state => ({ userInfos: state.userInfos }), mapDispatchToProps)
export default class CoreLayout extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      initflag: false,
      panes: [],
      activeKey: null,
      collapsed: false, // 默认：false
      isPaper: false,
    };
  }
  UNSAFE_componentWillMount() {
    const searchParams = getSupplierCode();
    if (searchParams) {
      getData({ api: API_GET_SETTLE_SIGNDATA_ISSIGNSUPPLIER, urlParams: [searchParams] })
        .then(data => {
          this.setState({
            isPaper: data.data,
          });
        })
        .catch(err => {});

      // 增加判断是否线上票核的灰度标记位逻辑

      getData({
        api: API_GET_PIAOHE_GRAY_SWITCH,
        searchParams: { supplierCode: searchParams + '' },
      })
        .then(data => {
          setSupplierCodePiaoSwitch(data?.data || false);
        })
        .catch(err => {});
    }
  }

  componentDidMount() {
    const userInfos = hasVariant('userInfos') ? JSON.parse(getVariant('userInfos')) : {};
    if (!this.props.userInfos || !this.props.userInfos.id) {
      if (!userInfos) {
        logOut(); // 返回登录页
        return;
      }
    }
    this.props.updateUser({ previewData: '已登录', userInfos });
    const {
      location: { pathname },
    } = this.props;
    if (
      pathname !== homePath ||
      pathname == '/' ||
      pathname !== registeredPath ||
      pathname !== supplierRegisteredPath
    ) {
      this.initTab();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.children !== this.props.children) {
      let nextCurPage = _.get(nextProps, 'location.query.curPage');
      const { pathname } = nextProps?.location;
      if (pathname === '/askPriceManagement/bidManagement') {
        nextCurPage = {
          path: pathname.replace(/^\//, ''),
          name: '商品报价管理',
        };
      }
      if (nextCurPage) this.curPage = nextCurPage;
      if (!this.curPage) return;
      if (Object.prototype.toString.call(this.curPage) === '[object String]') {
        // dropByCacheKey(`/${this.curPage}`)
        return;
      }
      const { name, path } = nextCurPage || this.curPage;
      const { panes } = this.state;

      this.setState({
        activeKey: path.replace(/^\//, ''),
      });

      if (panes.find(item => item.key === path)) return;
      const panesArr = [];
      const arr = panes.concat({
        content: nextProps.children,
        title: name,
        key: path.replace(/^\//, ''),
      });
      // console.log('arr', arr)
      arr.map(item => {
        item.title != undefined ? panesArr.push(item) : null;
      });

      this.setState({
        panes: panesArr,
      });
    }
  }

  initTab = () => {
    const {
      location: { pathname },
      children,
    } = this.props;
    const pathMap = getVariant('b2bUserMenu') || [];
    let title = getTitleNameFromPathMap(pathMap, pathname);
    if (pathname?.includes('order/orderNoticeDes')) {
      title = '订货通知单详情';
    }
    if (pathname?.includes('order/returnNoticeDes')) {
      title = '退货通知单详情';
    }
    if (pathname?.includes('order/returnFromDes')) {
      title = '退货单详情';
    }
    if (pathname?.includes('order/orderAcceptDes')) {
      title = '验收单详情';
    }
    this.setState({
      activeKey: pathname.replace(/^\//, ''),
      panes: [{ content: children, title, key: pathname.replace(/^\//, '') }],
    });
  };

  onLinkChange = ({ name, path }) => {
    this.curPage = { name, path };
    console.log('test', name, path);
    this.onTabChange(path);
  };

  onTabChange = (activeKey, name) => {
    // query:{ curPage : data, search }
    const newKey = activeKey.replace(/^\//, ''); // 去除开头的斜线('/')
    this.setState({ activeKey });
    history.replace({
      pathname: `/${newKey}`,
      query: { curPage: { name: '', path: activeKey } },
    });
  };

  onTabEdit = (targetKey, action) => {
    this[action](targetKey);
  };

  remove = targetKey => {
    let activeKey = this.state.activeKey;
    let lastIndex;
    this.state.panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const panes = this.state.panes.filter(pane => pane.key !== targetKey);
    if (panes.length && activeKey === targetKey) {
      if (lastIndex >= 0) {
        activeKey = panes[lastIndex].key;
      } else {
        activeKey = panes[0].key;
      }
    }
    this.setState({ panes, activeKey }, () => {
      this.curPage = '';
      history.replace({
        pathname: `/${activeKey}`,
        query: { curPage: { name: '', path: activeKey } },
      });
    });
  };

  onCollapse = collapsed => {
    this.setState({ collapsed });
  };

  render() {
    const { collapsed, panes, activeKey, isPaper } = this.state;
    const { location, userInfos } = this.props;
    return (
      <Layout>
        <GlobalSlider
          onLinkChange={this.onLinkChange}
          onCollapse={this.onCollapse}
          collapsed={collapsed}
          location={location}
          activeKey={activeKey}
          userInfos={userInfos}
        />
        <Layout style={{ overflowX: 'auto', overflowY: 'auto', height: '100vh' }}>
          <GlobalHeader
            onCollapse={this.onCollapse}
            collapsed={collapsed}
            location={location}
            isPaper={isPaper}
          />
          <Layout
            className="container"
            style={{ overflowX: 'auto', overflowY: 'auto', padding: '0px 20px', minWidth: '1090px', flex: 1 }}>
            {location.pathname !== homePath && location.pathname !== supplierRegisteredPath && (
              <Tabs
                hideAdd
                onChange={this.onTabChange}
                activeKey={activeKey}
                type="editable-card"
                className="csx-tabs-init"
                onEdit={this.onTabEdit}>
                {panes.map(pane => (
                  <TabPane closable={panes.length !== 1} tab={pane.title} key={pane.key}>
                    {pane.content}
                  </TabPane>
                ))}
              </Tabs>
            )}
            {(location.pathname === homePath || location.pathname == supplierRegisteredPath) &&
              this.props.children}
          </Layout>
        </Layout>
      </Layout>
    );
  }
}
